/**
 * @param form {HTMLFormElement}
 * @param jsCookie {JSCookie}
 */
function runAppendUtmCookieFieldsToForm(form, jsCookie) {
	if (!form) {
		return;
	}

	// Add UTM values to the form as hidden input fields
	[runFirstUtmCookieKey(), runUtmCookieKey()].forEach(cookieName => {
		const cookieStr = jsCookie.get(cookieName);

		if (!cookieStr) {
			return;
		}

		const cookie = JSON.parse(cookieStr);
		if (cookie) {
			Object.entries(cookie).forEach(([key, val]) => {
				if (val === 'Direct') {
					if (key === 'UTM_Medium__c' || key === 'First_UTM_Medium__c') {
						val = 'website';
					} else if (key === 'UTM_Source__c' || key === 'First_UTM_Source__c') {
						val = 'direct';
					}
				}

				if (val === 'NULL' || val === '') {
					val = 'not set';
				}

				if (['UTM_Source__c', 'First_UTM_Source__c'].includes(key)) {
					switch (val) {
						case "Google": {
							val = val.toLowerCase();
							break;
						}

						case "Yahoo Search": {
							val = "yahoo";
							break;
						}

						case "Microsoft Bing": {
							val = "bing";
							break;
						}
					}
				}

				if (typeof val !== "string") {
					val = "not set";
				}

				const input = document.createElement('input');
				input.type = 'hidden';
				input.name = key;
				input.value = val;
				form.appendChild(input);
			});
		}
	});

	const formAlreadyInitialized = form.hasAttribute('data-digitalpi-utms-added')
	if (!formAlreadyInitialized) {
		form.setAttribute('data-digitalpi-utms-added', "true");
	}
}
